import { useQuery } from "@msuite/ui/query";
import { useMemo } from "react";
import { getFilesWithAnnotations } from "@/api/files";

export function useFilesWithAnnotations(fileIds: string[]) {
	/** Computed */
	const sortedIds = useMemo(() => [...fileIds].sort(), [fileIds]);

	/** Query */
	const query = useQuery({
		queryKey: ["files-with-annotations", sortedIds.join(",")],
		queryFn: () => getFilesWithAnnotations(sortedIds),
		enabled: sortedIds.length > 0,
		staleTime: 1000 * 30,
	});

	/** Computed */
	const annotatedFileIds = useMemo(() => new Set(query.data ?? []), [query.data]);

	/** Return */
	return { ...query, annotatedFileIds };
}
